const inlineStyles = {
    groupLine: {
        stroke: '#cad7e1',
    },
    groupLabelText: {
        transform: 'translate(-10px, 6px)',
    },
};
export default inlineStyles;
